module.exports = {
  all: {
    configs: "Settings",
    popVox: "PopVOX",
  },
  popVox: {
    title: "PopVOX",
    image: "PopVOX banner",
    placement: "Placement",
    placementMap: "MAP",
    impactRule: "Impact limit in 24h",
    impactRuleHint: "Maximum number of times the banner can be shown to the same user within 24 hours",
    linkUrl: "Link URL (optional)",
  },
  PublicityType: {
    PopVOX: "PopVOX",
  },
  appConfig: {
    publicMapTitle: "Public map",
    publicMapEnabled: "Enable map view without login",
    endpoint: "Android/iOS endpoint",
    errorLoad: "Error loading settings",
    suggestedUsersTitle: "Suggested users (Find)",
    suggestedUsersRadiusKm: "Suggestion radius (km)",
    suggestedUsersRadiusKmHint: "Distance around the user's location used to suggest boxes/profiles on Find",
  },
  form: {
    name: "Name",
    isActive: "Active?",
    active: "Active",
    inactive: "Inactive",
    conclude: "Save",
    close: "Close",
    alert: {
      hasChangesPending: "There are unsaved changes. Are you sure you want to close?",
    },
    error: {
      required: "This field is required",
      update: "An error occurred",
      uploadError: "Error uploading image",
    },
  },
  dashboard: require('./dashboard/en-US.js'),
  voxPoint: {
    addTitle: "Add VoxPoint",
    editTitle: "Edit VoxPoint",
    status: "Status",
    username: "User",
    dateStart: "Start",
    dateEnd: "End",
    actions: "Actions",
    address: "Street",
    number: "Number",
    postalCode: "Postal code",
    hintNoNumber: "No number — the postal code centre will be used",
    files: "Files",
    addFile: "Add file",
    replaceFile: "Replace file",
    fileName: "Name",
    usernameChecking: "Checking...",
    usernameFound: "User found",
    usernameNotFound: "No user found with this username",
    usernameAlreadyVoxPoint: "This user is already registered as a VoxPoint",
    activateTitle: "Activate VoxPoint",
    deactivateTitle: "Deactivate VoxPoint",
    activatedSuccess: "User @{username} activated as a VoxPoint",
    deactivatedSuccess: "User @{username} deactivated as a VoxPoint",
    errorUserRequired: "Select a valid user before saving.",
    errorDateEndBeforeStart: "The End date cannot be before the Start date.",
    errorUserDeleted: "This user was deleted and cannot have the VoxPoint activated.",
    deleteConfirm: "Delete the VoxPoint of @{username}? It leaves the VoxPoints list and the map; the user account is not deleted.",
    deletedSuccess: "VoxPoint of @{username} deleted",
  },
  voxSpot: {
    estado: "Status",
    dateStart: "Start",
    dateEnd: "End",
    locations: "Locations",
    actions: "Actions",
    logo: "Map icon",
    address: "Street",
    number: "Number",
    postalCode: "Postal code",
    importExcel: "Import locations from Excel",
    addLocation: "Add location",
    errorReadingExcel: "Error reading the Excel file",
    errorInvalidTemplate: "The file does not match the expected template. Check that the City, Street Name, Door Number and Postal Code columns are present.",
    errorEmptyFile: "No locations found in the file.",
    errorIncompleteLocation: "Every location must have the Street and Postal Code filled in.",
    errorDuplicateLocation: "There are duplicate locations. Please remove the repeated ones before saving.",
    errorAllDuplicates: "No location was added because they all already existed.",
    warnSkippedDuplicates: "{count} skipped as duplicates",
    warnSkippedIncomplete: "{count} skipped for an incomplete address (Street or Postal Code missing)",
    hintNoNumber: "No number — the postal code centre will be used",
    errorDateEndBeforeStart: "The End date cannot be before the Start date.",
    noLocations: "No locations",
    deactivateTitle: "Deactivate VoxSpot",
    deactivatedSuccess: "VoxSpot {name} deactivated",
    deleteConfirm: "Delete the VoxSpot {name}? It leaves the VoxSpots list and the map. This cannot be undone.",
    deletedSuccess: "VoxSpot {name} deleted",
  },
  FcmComponents: {
    search: "Search",
    selected: "Selected",
    selecteds: "Selected",
  },
  users: {
    list: {
      loadError: "Could not load the users.",
      retry: "Try again",
      textSortHint: "To sort by name, username or e-mail, search or apply a filter.",
    },
  },
  interactionsTitle: {
    KEventCommentReply: "NEW REPLY",
  },
  interactionsBody: {
    KEventCommentReply: "@{username} replied to your comment on the event {eventTitle}",
  },
};
